module.exports = __webpack_public_path__ + "static/olha_sereda-73cd859d3c8c69ea4bf0a2ab91dcfd02.png";